import { connect } from 'react-redux'

import Pitch from './units'

const mapStateToProps = (state) => {
  const { Reference } = state

  const { servicePitch } = state.ProjectPitch
  let pitchLines = []
  Object.keys(servicePitch.pitchLine).forEach((key) => {
    pitchLines = [...pitchLines, ...servicePitch.pitchLine[key]]
  })

  let description = ''
  pitchLines.forEach((lineItem, index) => {
    description = description.concat(`${index + 1}. ${lineItem.description} `)
  })

  const contentWillBeShown = {
    createdAt: servicePitch.createdAt,
    updatedAt: servicePitch.updatedAt,
    currency: servicePitch.currency,
    idea: servicePitch.idea,
    profileId: servicePitch.profileId,
    price: servicePitch.price,
    description,
    quantity: servicePitch.pitchLineQty,
    status: Reference.statusDefinition.pitch[servicePitch.status],
    whtCreator: Math.ceil(servicePitch.whtCreator),
    clientPrice: Math.ceil(servicePitch.clientPrice),
    gcComm: Math.ceil(servicePitch.gcComm),
    gcCommPercentage: servicePitch.gcCommPercentage,
  }

  const content = Object.entries(contentWillBeShown)

  return {
    content,
    status,
    isLoading: state.ProjectPitch.isLoading,
    pitchReference: state.ProjectPitch.pitchReference,
    data: state.ProjectPitch.data,
    skip: state.ProjectPitch.data.count,
    rows: state.ProjectPitch.data.rows,
  }
}


export default connect(
  mapStateToProps,
)(Pitch)
